<template>
    <div class="slm-filters slm-event-list__filters" v-if="filters">
        <button class="slm-filters--toggle slm-event-list__filters--toggle slm-open-button" :aria-expanded="show ? 'true' : 'false'" @click="show = !show">
            Filtrera
        </button>
        <focus-trap :active="show" :allowOutsideClick="true" ref="focusTrap">
            <div class="slm-filters--wrapper slm-event-list__filters--wrapper" :class="show ? 'show' : ''">
                <button class="slm-filters--close slm-event-list__filters--close slm-close-button" :aria-expanded="show ? 'true' : 'false'" @click="show = false">
                    <span class="show-for-sr">Dölj filter</span>
                </button>
                <Filter :filters="filters" :id="this.id"/>
            </div>
        </focus-trap>
    </div>
</template>

<script>
import Filter from './Filter.vue'

export default {
    name: 'filters-component',
    props: ['id'],
    data() {
        return {
            show: false,
        }
    },
    computed: {
        filters() {
            return this.$store.state[this.id].filters;
        },
    },
    components: {
        Filter,
    }
}
</script>